
import "../CreateClient/CreateClient.css";
import React, { useEffect } from "react";
import StarRateIcon from "@mui/icons-material/StarRate";

interface propsData {
    accountManager: string,
    firstName: string,
    lastName: string,
    brokerageName:string,
    clientMainName: boolean,
    companyName: string,
    setAccountManager: (newAccountManager: string) => void,
    setFirstName: (newFirstName: string) => void,
    setLastName: (newLastName: string) => void,
    setBrokerageName: (newBrokerageName: string) => void,
    setClientMainName: (newClientMainName: boolean) => void,
    setCompanyName: (newCompanyName: string) => void,
    client: any
}

function PersonalData( props: propsData ) {

    const {
        firstName,
        lastName,
        accountManager,
        brokerageName,
        clientMainName,
        companyName,
        setCompanyName,
        setClientMainName,
        setAccountManager,
        setFirstName,
        setLastName,
        setBrokerageName,
        client
    } = props

    useEffect((): void => {
        if (client) {
            setAccountManager(client.accountManagerName);
            setFirstName(client.firstName);
            setLastName(client.lastName);
            setBrokerageName(client.businessData.brokerageName);
            setClientMainName(client.clientNameMain);
            setCompanyName(client.businessData.companyName);
        }
    }, [client])

    return(
        <div className="PersonalData">
            <div className="createClient-form-type">
                <div className="form-type-box">
                    <label> Account Manager </label>
                </div>
                <div className="form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { accountManager }
                        onChange = { e => setAccountManager(e.target.value) }
                    />
                </div>
            </div>
            <div className="createClient-form-name">
                <div className="form-fullName-Box">
                    <div className="form-name-box">
                        <label className="required">First Name <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/></label>
                        <div className="form-name-box-option">
                            <input
                                type = "text"
                                className = "form-input-Name"
                                style = {{ width: "390px" }}
                                value = { firstName }
                                onChange = { e => setFirstName(e.target.value) }
                            />
                        </div>
                    </div>
                    <div className="form-name-box">
                        <label className="required">Last Name <StarRateIcon style = {{color: "red", fontSize: "10px"}}/></label>
                        <div className="form-name-box-option">
                            <input
                                type = "text"
                                style = {{ width: "390px" }}
                                className = "form-input-Name"
                                value = { lastName }
                                onChange = {e => setLastName(e.target.value)}
                            />
                            <input
                                type = "radio"
                                id = "fullNameOption"
                                name = "nameOption"
                                style = {{
                                    width: "20px",
                                    height: "20px",
                                }}
                                checked = { clientMainName }
                                onClick = {() => {
                                    setClientMainName(true);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="form-name-box">
                    <label>Company Name</label>
                    <div className="form-name-box-option">
                        <input
                            type = "text"
                            value = { companyName }
                            onChange = {e => setCompanyName(e.target.value)}
                        />
                        <input
                            type = "radio"
                            style = {{
                                width: "20px",
                                height: "20px"
                            }}
                            checked = { !clientMainName }
                            id = "companyNameOption"
                            name = "nameOption"
                            onClick = {() => {
                                setClientMainName(false)
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="createClient-form-type">
                <div className="form-type-box">
                    <label> Brokerage Name </label>
                </div>
                <div className="form-type-box mrg-btm">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { brokerageName }
                        onChange = { e => setBrokerageName(e.target.value) }
                    />
                </div>
            </div>
        </div>
    )
}

export default PersonalData
